module.exports = __webpack_public_path__ + "static/wohnformen-fa9a0713a77c99fb1ea2eee8362822f3.png";